import './SurveyOver.css'
import React from 'react'
import { StandardFonts, StandardTextColors, StandardCornerRadii, StandardBackgroundColors, StandardDropShadows } from '../Styles/index'
import { isMobile } from 'react-device-detect';

interface FailureProps {

}

const SurveyFailureScreen = (props: FailureProps) => {
    let text = isMobile ? <span className={`survey-over-text ${StandardFonts.SmallText} ${StandardTextColors.Black}`}>We’re sorry, the survey is over. <span className={`survey-over-text ${StandardFonts.SmallTextBold} ${StandardTextColors.Black}`}>Once this tab closes automatically, </span> you'll be able to find another survey.</span>
        : <span className={`survey-over-text ${StandardFonts.SmallText} ${StandardTextColors.Black}`}>We’re sorry, the survey is over. <span className={`survey-over-text ${StandardFonts.SmallTextBold} ${StandardTextColors.Black}`}>Please close this tab</span> to find another survey.</span>


    return (
        <div className={`survey-container-root ${StandardBackgroundColors.BackgroundLightGrey}`}>
            <div className={`survey-over-container ${StandardBackgroundColors.White} ${StandardDropShadows.Normal} ${StandardCornerRadii.Normal}`}>
                {text}
            </div>
        </div>
    )
}

export default SurveyFailureScreen